module.exports = __webpack_public_path__ + "img/certificate-front.739615e9.png";